var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHkd = function SvgHkd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_107968",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_107968)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "#EA1A1A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5513_107968",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2V14H16V2H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5513_107968)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93474 7.78738C7.93474 7.78738 5.03989 5.20575 8.49432 3.70156C8.49432 3.70156 9.49893 4.80987 8.74528 6.0541C8.49802 6.46218 8.28948 6.75359 8.13277 6.97258C7.81169 7.42125 7.70813 7.56596 7.93474 7.78738ZM3.66235 5.93375C3.46354 9.69617 7.06701 8.26103 7.06701 8.26103C6.76777 8.36468 6.68462 8.20736 6.42691 7.71976C6.30107 7.48166 6.13361 7.16482 5.87904 6.76115C5.10307 5.53067 3.66235 5.93375 3.66235 5.93375ZM9.11905 7.91352C9.11905 7.91352 12.835 9.02598 10.343 11.8518C10.343 11.8518 8.96333 11.2732 9.11905 9.827C9.17016 9.35278 9.23558 9.00056 9.28476 8.73583C9.38555 8.19323 9.41807 8.01817 9.11905 7.91352ZM8.14235 8.78085C8.14235 8.78085 8.80852 12.602 5.16682 11.6363C5.16682 11.6363 5.06767 10.1437 6.43091 9.63641C6.87809 9.46999 7.22247 9.37101 7.48127 9.29662C8.01147 9.14423 8.18248 9.09507 8.14235 8.78085ZM12.7393 7.13765C10.4616 4.13656 8.63689 7.55924 8.63689 7.55924C8.79851 7.28682 8.96358 7.35325 9.47512 7.55911C9.72499 7.65966 10.0575 7.79348 10.5127 7.93733C11.8997 8.37568 12.7393 7.13765 12.7393 7.13765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08057 7.10405C5.08057 7.10405 5.80847 8.24963 7.00052 8.24963",
    stroke: "#EA1A1A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93018 5.5251C7.93018 5.5251 7.27694 6.73022 7.83657 7.78273",
    stroke: "#EA1A1A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0549 6.88079C11.0549 6.88079 9.52984 6.64959 8.7322 7.53545",
    stroke: "#EA1A1A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1642 9.67248C10.1642 9.67248 9.85983 8.16028 8.75459 7.71373",
    stroke: "#EA1A1A",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96667 10.4933C6.96667 10.4933 8.28358 9.69013 8.32518 8.49881",
    stroke: "#EA1A1A",
    strokeWidth: 0.5
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHkd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "HKD.7615fabd69a7c90b70e172066ab8dc83.svg";